export const getLatestRemark = remarks => {
  // For example: 📅 25-Apr-2025
  const regex = /📅 (\d{2}-\w{3}-\d{4})/g;

  // Get all matches case index number
  const matches = remarks.match(regex);
  if (!matches) {
    return remarks || "";
  }
  const targetMatch = matches[matches.length - 1];
  // Match the start of remark that exact match targetMatch with regex
  const startIndex = remarks.indexOf(targetMatch);

  // Get the text after the start of target regex, from start to end of the string
  const latestRemark = remarks.substring(startIndex, remarks.length);
  return latestRemark;
};
